import { httpsCallable } from 'firebase/functions';
import { FirebaseError } from 'firebase/app';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks';
import { functions } from '../../../../../../config/firebase';
import {
    fetchWhatsappGroupsStartReducer,
    fetchWhatsappGroupsFailureReducer,
    fetchWhatsappGroupSuccessReducer,
    setCurrentPageReducer,
    setWhatsappGroupFormReducer,
    fetchAddWhatsappGroupStartReducer,
    fetchAddWhatsappGroupSuccessReducer,
    fetchAddWhatsappGroupFailureReducer,
    fetchUpdateWhatsappGroupStartReducer,
    fetchUpdateWhatsappGroupSuccessReducer,
    fetchUpdateWhatsappGroupFailureReducer
} from '../slice/ManageWhatsappGroupSlice'
import {
    ResponseWhatsappGroupInterface,
    AddWhatsappGroupInterface,
    ManageWhatsappGroupResponseInterface,
    WhatsappGroupInterface,
    RequestWhatsappGroupInterface
} from "../../domain/interfaces/WhatsappGroupInterface";

const useManageWhatsappGroupsInfrastructure = () => {
    const dispatch = useAppDispatch();
    const manageWhatsappGroupsState = useAppSelector((state) => state.manageWhatsappGroups);

    const getWhatsappGroupListCallable = httpsCallable<RequestWhatsappGroupInterface, ResponseWhatsappGroupInterface>(functions, 'getWhatsappGroupList');
    const addWhatsappGroupCallable = httpsCallable<AddWhatsappGroupInterface, ManageWhatsappGroupResponseInterface>(functions, 'addWhatsappGroup');
    const updateWhatsappGroupCallable = httpsCallable<WhatsappGroupInterface, ManageWhatsappGroupResponseInterface>(functions, 'updateWhatsappGroup');

    const fetchWhatsappGroupsInfrastructure = async (page?: number) => {
        dispatch(fetchWhatsappGroupsStartReducer());
        try {
            const targetPage = page ?? manageWhatsappGroupsState.pagination.currentPage;
            const lastVisibleId = manageWhatsappGroupsState.paginationRequest.pageCursors[targetPage] ?? null;
            
            const request = {
                ...manageWhatsappGroupsState.paginationRequest,
                lastVisibleId: lastVisibleId,
            };
            
            const result = await getWhatsappGroupListCallable(request);
            dispatch(fetchWhatsappGroupSuccessReducer(result.data));
        } catch (error) {
            const errorMessage = error instanceof FirebaseError ? error.message : 'Ocurrió un error inesperado.';
            dispatch(fetchWhatsappGroupsFailureReducer(errorMessage));
        }
    };

    const setCurrentPageInfrastructure = (page: number) => {
        dispatch(setCurrentPageReducer(page))
    }

    const setWhatsappGroupFormInfrastructure = (form: AddWhatsappGroupInterface) => {
        dispatch(setWhatsappGroupFormReducer(form))
    }

    const addWhatsappGroupInfrastructure = async () => {
        dispatch(fetchAddWhatsappGroupStartReducer());
        try {
            const result = await addWhatsappGroupCallable(manageWhatsappGroupsState.whatsappGroupForm);
            dispatch(fetchAddWhatsappGroupSuccessReducer(result.data));
        } catch (error) {
            const errorMessage = error instanceof FirebaseError ? error.message : 'Ocurrió un error inesperado.';
            dispatch(fetchAddWhatsappGroupFailureReducer(errorMessage));
        }
    };

    const updateWhatsappGroupInfrastructure = async () => {
        dispatch(fetchUpdateWhatsappGroupStartReducer());
        try {
            const result = await updateWhatsappGroupCallable(manageWhatsappGroupsState.whatsappGroupForm);
            dispatch(fetchUpdateWhatsappGroupSuccessReducer(result.data));
        } catch (error) {
            const errorMessage = error instanceof FirebaseError ? error.message : 'Ocurrió un error inesperado.';
            dispatch(fetchUpdateWhatsappGroupFailureReducer(errorMessage));
        }
    };

    return {
        fetchWhatsappGroupsInfrastructure,
        setCurrentPageInfrastructure,
        addWhatsappGroupInfrastructure,
        setWhatsappGroupFormInfrastructure,
        updateWhatsappGroupInfrastructure,
        manageWhatsappGroupsState
    }
}

export default useManageWhatsappGroupsInfrastructure;
